import { NewJoinersAndAllocationsPersonalDataCustomDetailEntry } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewJoinersAndAllocationsModal/useNewJoinersAndAllocationsModalController';
import { useCommonYupValidation } from '@dealstack/frontend/shared/other/react/form/useCommonYupValidation';
import { generateUUID } from '@dealstack/frontend/shared/other/react/generateUUID';
import { yupResolver } from '@hookform/resolvers/yup';
import { useFieldArray, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { CustomDetailDataTypeEnum } from '@dealstack/shared/lib/generated/models/CustomDetailDataTypeEnum.ts';
import { CustomDetailEnum } from '@dealstack/shared/lib/generated/models/CustomDetailEnum.ts';

type PersonalDataCustomDetailsFormValues = {
	rows: NewJoinersAndAllocationsPersonalDataCustomDetailEntry[];
};

export const useNewJoinersAndAllocationsPersonalDataTagManagerModalController = ({
	data,
	detailsType,
	onUpdateCustomDetails,
}: {
	data?: NewJoinersAndAllocationsPersonalDataCustomDetailEntry[];
	detailsType: CustomDetailEnum;
	onUpdateCustomDetails: (
		data: CustomDetailEnum,
		fields: NewJoinersAndAllocationsPersonalDataCustomDetailEntry[]
	) => unknown;
}) => {
	const commonYup = useCommonYupValidation();
	const personalDataForm = useForm<PersonalDataCustomDetailsFormValues>({
		defaultValues: {
			rows: data?.map((item) => {
				if (item.id == null) {
					return item;
				}
				// * This if is required to unify all remote & locally added details in case of removeCustomDetailLocally method on mixed data before save draft
				return {
					...item,
					localId: item.id,
				};
			}),
		},
		mode: 'all',
		resolver: yupResolver(
			Yup.object().shape({
				rows: Yup.array().of(
					Yup.object().shape({
						name: commonYup.string.required,
					})
				),
			})
		),
	});

	const {
		fields: formPersonalDetailsRows,
		append,
		remove,
	} = useFieldArray({
		name: 'rows',
		control: personalDataForm.control,
	});

	const onModalSaveButtonClicked = () => {
		const values = personalDataForm.getValues()?.rows;
		onUpdateCustomDetails(detailsType, values);
	};

	const onAddNewDetailButtonClicked = () => {
		append({
			name: '',
			instruction: '',
			type: detailsType,
			localId: generateUUID(),
			fileId: '',
			dataType: CustomDetailDataTypeEnum.STRING,
		});
	};

	const onRemoveRowClicked = (id: string) => {
		remove(formPersonalDetailsRows.findIndex((item) => item.id === id));
	};

	return {
		formPersonalDetailsRows,
		personalDataForm,
		onModalSaveButtonClicked,
		onAddNewDetailButtonClicked,
		onRemoveRowClicked,
	};
};
